/* eslint-disable max-classes-per-file */

export class HTTPError extends Error {
  get code() {
    return this.response.status;
  }
}

export class BadDataError extends HTTPError {
  constructor(message = "Bad data") {
    super(message);
  }
}

export class UnauthorizedError extends HTTPError {
  constructor(message = "Unauthorized") {
    super(message);
  }
}

export class ForbiddenError extends HTTPError {
  constructor(message = "Forbidden") {
    super(message);
  }
}

export class NotFoundError extends HTTPError {
  constructor(message = "Not Found") {
    super(message);
  }
}

export class ConflictError extends HTTPError {
  constructor(message = "Conflict") {
    super(message);
  }
}

export class UnprocessibleEntityError extends HTTPError {
  constructor(message = "Unprocessible Entity") {
    super(message);
  }
}

export class InternalServerError extends HTTPError {
  constructor(message = "Internal Server Error") {
    super(message);
  }
}
